import { instance, instanceWithAuth } from "@/api/index";

function searchAddress(param) {
    return instance.get("/common/address", { params: param });
}
function getNotice() {
    return instance.get("/common/notice");
}
function sendQna(param) {
    return instance.post("/common/send-qna", param)
}
function sendQnaAuth(param) {
    return instanceWithAuth.post("/common/send-qna-auth", param)
}
function sendAuthMmsAuth(param) {
    return instanceWithAuth.post("/common/send-cell-auth", param);
}
function sendAuthMms(param) {
    return instanceWithAuth.post("/common/send-cell", param);
}
function checkCellAuthWithId(param) {
    return instanceWithAuth.post("/common/check-cell-auth", param);
}
function checkCellAuth(param) {
    return instance.post("/common/check-cell", param);
}
function saveSurvey(param) {
    return instance.post("/common/service-survey", param);
}
function getContactInfo() {
    return instance.get("/common/contact-info");
}
function getReportView(param) {
    return instance.post("/common/report-view", param);
}
function getSamsungReportView(param) {
    return instance.post("/common/samsung-report-view", param);
}

export {
    searchAddress, getNotice, sendQna, sendQnaAuth, sendAuthMmsAuth,
    sendAuthMms, checkCellAuth, checkCellAuthWithId, saveSurvey,
    getContactInfo, getReportView, getSamsungReportView
};